import { render, staticRenderFns } from "./PrescriberForm.vue?vue&type=template&id=cd42d178&scoped=true&"
import script from "./PrescriberForm.vue?vue&type=script&lang=js&"
export * from "./PrescriberForm.vue?vue&type=script&lang=js&"
import style0 from "./PrescriberForm.vue?vue&type=style&index=0&id=cd42d178&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd42d178",
  null
  
)

export default component.exports